<template>
  <v-simple-table>
    <tbody>
      <tr>
        <th>Id</th>
        <th>Title</th>
        <th>Number</th>
        <th>Floor</th>
        <th>Area</th>
        <th>Rooms</th>
        <th>Room sizes</th>
        <th>Rooms data</th>
        <th>Bathrooms</th>
        <th>Balconies</th>
        <th>Notes</th>
        <th>Floor plan</th>
        <th>Unconfirmed / confirmed</th>
      </tr>
      <tr v-for="apartment in $store.state.apartments" :key="apartment.id">
        <td>{{ apartment.id }}</td>
        <td>{{ apartment.title }}</td>
        <td>{{ apartment.number }}</td>
        <td>{{ apartment.floor }}</td>
        <td>{{ apartment.area }}</td>
        <td>{{ apartment.rooms }}</td>
        <td>{{ apartment.room_sizes }}</td>
        <td>
          <v-dialog width="500">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">mdi-eye</v-icon>
            </template>
            <v-card>
              <v-card-title>
                {{ apartment.title }}
                {{ apartment.number }}
              </v-card-title>
              <pre>{{ apartment.rooms_attrs }}</pre>
            </v-card>
          </v-dialog>
        </td>
        <td>{{ apartment.bathrooms }}</td>
        <td>{{ apartment.balconies }}</td>
        <td>{{ apartment.notes }}</td>
        <td>
          <a v-if="apartment.floor_plan" :href="apartment.floor_plan" target="_blank">
            <v-icon>mdi-floor-plan</v-icon>
          </a>
          <v-icon v-else color="error">mdi-exclamation</v-icon>
        </td>
        <td>
          {{ apartment.unconfirmed_selections }} /
          <strong>{{ apartment.confirmed_selections }}</strong>
        </td>
      </tr>
    </tbody>
  </v-simple-table>
</template>

<script>
export default {};
</script>

<style>
</style>
